import React from 'react';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { fade } from '@material-ui/core/styles/colorManipulator';

const useStyles = makeStyles(theme => ({
  root: props => ({
    borderRadius: '0.375rem',
    height: '1.5rem',
    fontSize: '0.75rem',
    fontWeight: '600',
    padding: '0.125rem !important',
    fontFamily: theme.typography.fontFamily,
    cursor: props.onClick ? 'pointer' : 'default',
    flexDirection: props.iconAtEnd ? 'row-reverse' : 'row',
  }),
  label: props => ({
    paddingLeft: '0.5rem',
    paddingRight: props.labelPadding ? '0.2rem' : '0.5rem',
  }),
  icon: props => ({
    width: '1rem',
    height: '1rem',
    marginLeft: props.iconAtEnd ? 0 : 'inherit',
    marginRight: props.iconAtEnd ? 0 : 'inherit',
  }),
  deleteIcon: {
    width: '0.875rem',
    height: '0.875rem',
    color: theme.palette.secondary['900'],
    margin: '0',
    marginLeft: '-0.25rem',
    marginTop: '-0.125rem',
    marginRight: '0.125rem',
  },
  colorGray: {
    backgroundColor: `${theme.palette.secondary['200']} !important`,
    color: `${theme.palette.secondary['900']} !important`,
  },
  colorInterested: {
    backgroundColor: `${theme.palette.interested} !important`,
    color: `${theme.palette.secondary['0']} !important`,
  },
  colorUncategorized: {
    backgroundColor: `${theme.palette.uncategorized} !important`,
    color: `${theme.palette.secondary['0']} !important`,
  },
  colorNotInterested: {
    backgroundColor: `${theme.palette.notInterested} !important`,
    color: `${theme.palette.secondary['0']} !important`,
  },
  colorBounced: {
    backgroundColor: `${theme.palette.bounced} !important`,
    color: `${theme.palette.secondary['0']} !important`,
  },
  colorNotNow: {
    backgroundColor: `${theme.palette.notNow} !important`,
    color: `${theme.palette.secondary['0']} !important`,
  },
  colorBlacklist: {
    backgroundColor: `${theme.palette.blacklist} !important`,
    color: `${theme.palette.secondary['0']} !important`,
  },
  colorSponsorship: {
    backgroundColor: `${theme.palette.sponsorship} !important`,
    color: `${theme.palette.secondary['0']} !important`,
  },
  colorAutoReply: {
    backgroundColor: `${theme.palette.autoReply} !important`,
    color: `${theme.palette.secondary['0']} !important`,
  },
  colorMarkAsFinished: {
    backgroundColor: `${theme.palette.markAsFinished} !important`,
    color: `${theme.palette.secondary['0']} !important`,
  },
  colorDeliveryStatusBadge: {
    backgroundColor: `${fade(theme.palette.deliveryStatusBadge, 0.1)} !important`,
    color: `${theme.palette.deliveryStatusBadge} !important`,
  },
  colorErrored: {
    backgroundColor: `${fade(theme.palette.erroredBadge, 0.1)} !important`,
    color: `${theme.palette.erroredBadge} !important`,
  },
  colorCompleted: {
    backgroundColor: `${fade(theme.palette.completedBadge, 0.1)} !important`,
    color: `${theme.palette.completedBadge} !important`,
  },
  colorActive: {
    backgroundColor: `${fade(theme.palette.activeBadge, 0.1)} !important`,
    color: `${theme.palette.activeBadge} !important`,
  },
  colorInactive: {
    backgroundColor: `${fade(theme.palette.inactiveBadge, 0.1)} !important`,
    color: `${theme.palette.inactiveBadge} !important`,
  },
}));

const Tag = (props) => {
  const { className, onClick } = props;
  const classes = useStyles(props);
  return (
    <Chip
      className={className}
      onClick={onClick}
      classes={{
        root: classes.root,
        icon: classes.icon,
        label: classes.label,
        deleteIcon: classes.deleteIcon,
        colorGray: classes.colorGray,
        colorInterested: classes.colorInterested,
        colorUncategorized: classes.colorUncategorized,
        colorNotInterested: classes.colorNotInterested,
        colorNotNow: classes.colorNotNow,
        colorBlacklist: classes.colorBlacklist,
        colorSponsorship: classes.colorSponsorship,
        colorBounced: classes.colorBounced,
        colorAutoReply: classes.colorAutoReply,
        colorMarkAsFinished: classes.colorMarkAsFinished,
        colorDeliveryStatusBadge: classes.colorDeliveryStatusBadge,
        colorErrored: classes.colorErrored,
        colorCompleted: classes.colorCompleted,
        colorActive: classes.colorActive,
        colorInactive: classes.colorInactive,
      }}
      deleteIcon={<CloseRoundedIcon />}
      {...props}
    >
      {props.children}
    </Chip>
  );
};

Tag.propTypes = {
  iconAtEnd: PropTypes.bool,
  color: PropTypes.string,
  labelPadding: PropTypes.bool,
};

Tag.defaultProps = {
  iconAtEnd: false,
  color: 'gray',
  labelPadding: false,
};


export default Tag;
